export const firebaseProjectToken = '86b2782e-1f86-44df-8bce-ec99c17d4d14';

export const
  firebaseVapidKey = 'BJUafpj8GZ1xowqm7WmGgMD4-fLglcCMKtb8AeoHmRCm3iiQFTLubWBGEIlC1VBBLjZzRBsiQSn_8TS6IaLIZTw';

export const firebaseConfig = {
  apiKey: 'AIzaSyDMmu440WheUhtYYvCmGvfTZMCkcUR40yE',
  authDomain: 'health-rb-life.firebaseapp.com',
  projectId: 'health-rb-life',
  storageBucket: 'health-rb-life.appspot.com',
  messagingSenderId: '549968314176',
  appId: '1:549968314176:web:7758c85a3c1499992184a5',
};
